import { combineReducers } from "redux";
import authService from "./Auth/Auth";
import barcodeService from "./BarcodePicker/BarcodePicker";
import forgotPasswordService from "./ForgotPassword/ForgotPassword";
import gateService from "./Gates/Gates";
import musterService from "./Muster/Muster";
import scanService from "./RecentScans/RecentScans";

const rootReducer = combineReducers({
  authService,
  gateService,
  scanService,
  musterService,
  forgotPasswordService,
  barcodeService,
});

export default rootReducer;
